import React from "react";

import { Model } from "@flowable/forms";
import { noop } from "lodash";

export const withFlowableStatefulFormComponent = WrappedComponent => {
	if (process.env.NODE_ENV === "test") {
		return class extends React.Component {
			state = {
				touched: false,
			};

			render () {
				return (
					<WrappedComponent
						config={{}}
						bem={() => className => className}
						dispatchFocusEvent={noop}
						dispatchBlurEvent={noop}
						onChange={noop}
						{...this.props}
						setTouched={() => {
							this.setState({ touched: true });
							this.props.setTouched && this.props.setTouched();
						}}
						isTouched={() => this.state.touched}
						Components={{
							label: props => {
								return <label>{props.config?.label}</label>;
							},
							description: props => {
								return <p>{props.config?.description}</p>;
							},
							errorList: props => {
								return props.config?.$errors?.map((error, index) => (
									<p key={index}>{error.message}</p>
								));
							},
							...this.props.Components,
						}}
					/>
				);
			};
		};
	}

	return class extends Model.StatefulFormComponent {
		render () {
			return (
				<WrappedComponent
					{...this.props}
					bem={this.bem.bind(this)}
					dispatchFocusEvent={this.dispatchFocusEvent.bind(this)}
					dispatchBlurEvent={this.dispatchBlurEvent.bind(this)}
					setTouched={this.setTouched.bind(this)}
					isTouched={this.isTouched.bind(this)}
				/>
			);
		};
	};
};
